import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createExceptionResult, createSuccessResult } from '@atlassian/commerce-resultful';
import { createReCaptchaClientFactory } from './client';
import { ENTERPRISE_DIRECT_RECAPTCHA_SCRIPT_URL, ENTERPRISE_GOOGLE_RECAPTCHA_SCRIPT_URL, FREE_DIRECT_RECAPTCHA_SCRIPT_URL, FREE_GOOGLE_RECAPTCHA_SCRIPT_URL } from './constants';

var isScriptSrcAlreadyDeclared = function isScriptSrcAlreadyDeclared(src) {
  return document.querySelector("script[src*=\"".concat(src, "\"]")) !== null;
};

export var isFreeReCaptchaScriptAlreadyDeclared = function isFreeReCaptchaScriptAlreadyDeclared() {
  return isScriptSrcAlreadyDeclared(FREE_DIRECT_RECAPTCHA_SCRIPT_URL) || isScriptSrcAlreadyDeclared(FREE_GOOGLE_RECAPTCHA_SCRIPT_URL);
};
export var isEnterpriseReCaptchaScriptAlreadyDeclared = function isEnterpriseReCaptchaScriptAlreadyDeclared() {
  return isScriptSrcAlreadyDeclared(ENTERPRISE_DIRECT_RECAPTCHA_SCRIPT_URL) || isScriptSrcAlreadyDeclared(ENTERPRISE_GOOGLE_RECAPTCHA_SCRIPT_URL);
};
/**
 * @see https://www.google.com/recaptcha/about/
 */

export var loadFreeReCaptchaScript = createReCaptchaClientFactory({
  isScriptAlreadyDeclared: isFreeReCaptchaScriptAlreadyDeclared,
  getGlobalReCaptchaObject: function getGlobalReCaptchaObject() {
    return globalThis.grecaptcha;
  },
  reCaptchaScriptUrl: FREE_DIRECT_RECAPTCHA_SCRIPT_URL,
  triggerReCaptchaChallenge: function triggerReCaptchaChallenge(grecaptcha, sitekey, element) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var resolve;
    var reject;
    var tokenPromise = new Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    });
    var widgetId = grecaptcha.render(element, _objectSpread(_objectSpread({}, options), {}, {
      sitekey: sitekey,
      // In the free tier version of reCAPTCHA - tokens appear here
      callback: function callback(token) {
        try {
          grecaptcha.reset(widgetId);
          resolve(token);
        } catch (err) {
          reject(err);
        }
      },
      isolated: true,
      size: 'invisible'
    }));

    var retriggerReCaptcha = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _token;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return grecaptcha.execute(widgetId);

              case 3:
                _context.next = 5;
                return tokenPromise;

              case 5:
                _token = _context.sent;
                return _context.abrupt("return", createSuccessResult(_token));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", createExceptionResult(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function retriggerReCaptcha() {
        return _ref.apply(this, arguments);
      };
    }();

    var tokenResultPromise = retriggerReCaptcha();
    return {
      tokenResultPromise: tokenResultPromise,
      retriggerReCaptcha: retriggerReCaptcha
    };
  }
});
/**
 * @see https://cloud.google.com/recaptcha-enterprise
 */

export var loadEnterpriseReCaptchaScript = createReCaptchaClientFactory({
  isScriptAlreadyDeclared: isEnterpriseReCaptchaScriptAlreadyDeclared,
  getGlobalReCaptchaObject: function getGlobalReCaptchaObject() {
    return globalThis.grecaptcha.enterprise;
  },
  reCaptchaScriptUrl: ENTERPRISE_DIRECT_RECAPTCHA_SCRIPT_URL,
  triggerReCaptchaChallenge: function triggerReCaptchaChallenge(grecaptcha, sitekey, element) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var widgetId = grecaptcha.render(element, _objectSpread(_objectSpread({}, options), {}, {
      sitekey: sitekey,
      isolated: true,
      size: 'invisible'
    }));

    var retriggerReCaptcha = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _token2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return grecaptcha.execute(widgetId);

              case 3:
                _token2 = _context2.sent;
                return _context2.abrupt("return", createSuccessResult(_token2));

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", createExceptionResult(_context2.t0));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      return function retriggerReCaptcha() {
        return _ref2.apply(this, arguments);
      };
    }();

    var firstTokenResultPromise = retriggerReCaptcha().then(function (result) {
      grecaptcha.reset(widgetId);
      return result;
    });
    return {
      tokenResultPromise: firstTokenResultPromise,
      retriggerReCaptcha: retriggerReCaptcha
    };
  }
});